// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import * as React from "react";
import * as jsxRuntime from "react/jsx-runtime";
export function AnimatedResourceValue({
  value: u
}) {
  const [o, m] = React.useState(u),
    r = React.useRef(u);
  return React.useEffect(() => {
    const g = r.current,
      j = u - g;
    if (!j) return;
    const B = performance.now(),
      U = 420,
      N = X => {
        const M = Math.min(1, (X - B) / U);
        m(Math.round(g + j * (1 - (1 - M) ** 3))), M < 1 ? window.requestAnimationFrame(N) : r.current = u;
      },
      y = window.requestAnimationFrame(N);
    return () => window.cancelAnimationFrame(y);
  }, [u]), jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: o.toLocaleString("ru-RU")
  });
}
